import {Component, OnInit, Input, OnChanges} from '@angular/core';
import { ProjectForm } from '../../../project/models/form.model';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { formTypes } from '../../../form/form.constants';
import { StepApplication } from '../../models/step/step-application.model';
import {
  logoRequirements,
  careerLearningTypes,
  creditTypes,
  baseCreditTypes
} from '../../../entertainment/entertainment.constants';
import { FormIdentifier } from '../../../project/models/form-identifier.model';
import { FormValidationService } from '../../../form/services/validation.service';
import { ExpenditurePerCreditType } from '../../../entertainment/credit.constants';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { events } from '../../../fastlane-common/event/event.constants';
import {
  getCalculatedCreditAmount,
  updateCreditTypesAndCreditsOnExpenditureChanged
} from '../../../entertainment/credit.functions';
import * as _ from 'underscore';
import {
  vfxActions,
  legislationRuleNames
} from '../../../project/project.constants';
import { ProjectDetailService } from '../../../project/services/project-shared.service';
import {
  referralAgencies, primaryActivityTypes, primaryAffiliationTypes,
  approxGrossSales, approxPercentageExport,
  usOriginContacts, fedOrgs } from '../../step.constants';
import { FormShareService } from '../../../form/services/share.service';
import {userType} from '../../../user/user.constants';
import {UserContextService} from '../../../user/services/user-context.service';
import {NgMultiSelectOption} from '../../../shared/interfaces/ng-multi-select-option.interface';
declare var $: any;

@Component({
  selector: 'fl-step-app',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.css']
})
export class StepAppComponent implements OnInit, OnChanges {
  @Input() form: ProjectForm;
  @Input() hideCredits = false;
  hideDeposit = false;
  stepApplication: StepApplication;
  currentFormId: FormIdentifier;
  stepApplicationForm: FormGroup;
  referralAgencyForm: FormGroup;
  companyDescriptionForm: FormGroup;
  productInformationForm: FormGroup;
  referralAgencies = referralAgencies;
  primaryActivityTypes = primaryActivityTypes;
  primaryAffiliationTypes = primaryAffiliationTypes;
  approxGrossSales = approxGrossSales;
  approxPercentageExport = approxPercentageExport;
  usOriginContacts = usOriginContacts;
  fedOrgs = fedOrgs;
  isDisabled = false;

  isOtherPrimaryActivity = false;
  isOtherPrimaryAffiliation = false;
  isOtherFederalOrg = false;

  // set up dict? with corresponding checkboxes
  public dict: { [id: string]: string } = {
    primaryActivity: 'primaryActivityDescription',
    primaryAffliation: 'primaryAffiliationDescription',
    isProductCertified: 'productCertifiedDescription',
    isForeignRepresentation: 'foreignRepresentationDescription',
    isExportUSOrigin: 'usOriginContact',
    tradeShowsAndMissions: 'tradeShowsAndMissionsDescription',
    globalMarketEvents: 'globalMarketEventsDescription',
    usCommercialServices: 'usCommercialServicesDescription',
    exportWorkshops: 'exportWorkshopsDescription',
    ecommAndWebGlobalization: 'ecommAndWebGlobalizationDescription',
    designMarketingMedia: 'designMarketingMediaDescription',
    complianceTestingAndShipping: 'complianceTestingAndShippingDescription',
    otherExpenseOrActivity: 'otherExpenseOrActivityDescription'
  }

  public fields: string[] = [
    'primaryActivity',
    'primaryAffliation',
    'isProductCertified',
    'isForeignRepresentation',
    'isExportUSOrigin',
    'tradeShowsAndMissions',
    'globalMarketEvents',
    'usCommercialServices',
    'exportWorkshops',
    'ecommAndWebGlobalization',
    'designMarketingMedia',
    'complianceTestingAndShipping',
    'otherExpenseOrActivity'
  ]


  exportLocationOptions: any[] = [
    'Angola', 'Argentina', 'Australia', 'Bahrain', 'Bangladesh', 'Benin', 'Bolivia', 'Botswana', 'Brazil',
    'Brunei Darussalam', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde',
    'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Costa Rica', 'Cote d\'Ivoire',
    'Democratic Republic of Congo', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
    'Ethiopia', 'Gabon', 'Gambia', 'Ghana', 'Guatemala', 'Guinea', 'Haiti', 'Honduras', 'Hong Kong', 'Iceland',
    'India', 'Indonesia', 'Israel', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Laos', 'Lesotho',
    'Liberia', 'Malaysia', 'Mali', 'Mexico', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'New Zealand', 'Nicaragua',
    'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Panama', 'Paraguay', 'Peru', 'Philippines', 'Qatar',
    'Republic of Congo', 'Russia', 'Rwanda', 'Saudi Arabia', 'Senegal', 'Singapore', 'South Africa', 'South Korea',
    'Sri Lanka', 'Sudan', 'Switzerland', 'Taiwan', 'Tanzania', 'Thailand', 'Turkey', 'Uganda', 'Ukraine',
    'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Venezuela', 'Vietnam', 'Zambia', 'Zimbabwe', 'Other, please list'
  ].map(name => {
        return { id: name, text: name }
      });

  dropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    itemsShowLimit: 5,
    allowSearchFilter: true
  };

  multiSelects: any = {};

  constructor(
    private formBuilder: FormBuilder,
    private pubsubService: PublishSubscribeService,
    private validationService: FormValidationService,
    private projectDetailService: ProjectDetailService,
    private shareService: FormShareService,
    private userContext: UserContextService,
  ) {}

  ngOnInit() {
    const that = this;
    this.stepApplication = <StepApplication>this.shareService.form;

    if (this.stepApplication.primaryActivity && this.stepApplication.primaryActivity === 'Other') { this.isOtherPrimaryActivity = true; }
    if (this.stepApplication.primaryAffiliation && this.stepApplication.primaryAffiliation.includes('Other')) {
      this.isOtherPrimaryAffiliation = true;
    }
    if (this.stepApplication.otherOrgs && this.stepApplication.otherOrgs.includes('Other')) { this.isOtherFederalOrg = true; }

    this.currentFormId = new FormIdentifier(<FormIdentifier>{
      formType: this.stepApplication.type,
      formIndex: this.stepApplication.formIndex,
      projectGuid: null
    });

    this.referralAgencyForm = this.formBuilder.group({
      referralAgency: [
        this.stepApplication.referralAgency,
        Validators.required
      ]
    })

    this.companyDescriptionForm = this.formBuilder.group({
      primaryActivity: [
        this.stepApplication.primaryActivity,
        Validators.required
      ],
      primaryActivityDescription: [
        this.stepApplication.primaryActivityDescription
      ],
      primaryAffiliation: [
        this.stepApplication.primaryAffiliation,
        Validators.required],
      primaryAffiliationDescription: [
        this.stepApplication.primaryAffiliationDescription
      ],
      businessType: [
        this.stepApplication.businessType,
        Validators.required
      ],
      naicsCode: [
        this.stepApplication.naicsCode,
        Validators.required
      ],
      yearEst: [
        this.stepApplication.yearEst,
        Validators.required
      ],
      totalEmployees: [
        this.stepApplication.totalEmployees,
        Validators.required
      ],
      forProfit: [
        this.stepApplication.forProfit,
        Validators.required
      ],
      estGrossSalesLastYear: [
        this.stepApplication.estGrossSalesLastYear,
        Validators.required
      ],
      existingExportStrategy: [
        this.stepApplication.existingExportStrategy,
        Validators.required
      ],
      estAnnualExportPercentage: [
        this.stepApplication.estAnnualExportPercentage,
        Validators.required
      ],
      exportLocation: [
        !this.stepApplication.exportLocation ? [] : this.stepApplication.exportLocation.map(name => {
          return { id: name, text: name }
        }),
        Validators.required
      ],
      exportLocationOtherDescription: [
        this.stepApplication.exportLocationOtherDescription
      ],
      exportLocationInterest: [
        !this.stepApplication.exportLocationInterest ? [] : this.stepApplication.exportLocationInterest.map(name => {
          return { id: name, text: name }
        }),
        Validators.required
      ],
      exportLocationInterestOtherDescription: [
        this.stepApplication.exportLocationInterestOtherDescription
      ],
    })

    this.productInformationForm = this.formBuilder.group({
      productDescription: [
        this.stepApplication.productDescription,
        Validators.required
      ],
      salesChannelsDescription: [
        this.stepApplication.salesChannelsDescription,
        Validators.required
      ],
      isProductCertified: [
        this.stepApplication.isProductCertified,
        Validators.required
      ],
      productCertifiedDescription: [
        this.stepApplication.productCertifiedDescription
      ],
      isForeignRepresentation: [
        this.stepApplication.isForeignRepresentation,
        Validators.required
      ],
      foreignRepresentationDescription: [
        this.stepApplication.foreignRepresentationDescription
      ],
      isExportUSOrigin: [
        this.stepApplication.isExportUSOrigin,
        Validators.required
      ],
      usOriginContact: [
        this.stepApplication.usOriginContact
      ],
      otherOrgs: [
        this.stepApplication.otherOrgs,
        Validators.required
      ],
      otherOrgsDescription: [
        this.stepApplication.otherOrgsDescription
      ],
      optInSBA: [
        this.stepApplication.optInSBA,
        Validators.required
      ]
    })

    this.stepApplicationForm = this.formBuilder.group({
      tradeShowsAndMissions: [
        this.stepApplication.tradeShowsAndMissions
      ],
      tradeShowsAndMissionsDescription: [
        this.stepApplication.tradeShowsAndMissionsDescription
      ],
      globalMarketEvents: [
        this.stepApplication.globalMarketEvents
      ],
      globalMarketEventsDescription: [
        this.stepApplication.globalMarketEventsDescription
      ],
      usCommercialServices: [
        this.stepApplication.usCommercialServices
      ],
      usCommercialServicesDescription: [
        this.stepApplication.usCommercialServicesDescription
      ],
      exportWorkshops: [
        this.stepApplication.exportWorkshops
      ],
      exportWorkshopsDescription: [
        this.stepApplication.exportWorkshopsDescription
      ],
      ecommAndWebGlobalization: [
        this.stepApplication.ecommAndWebGlobalization
      ],
      ecommAndWebGlobalizationDescription: [
        this.stepApplication.ecommAndWebGlobalizationDescription
      ],
      designMarketingMedia: [
        this.stepApplication.designMarketingMedia
      ],
      designMarketingMediaDescription: [
        this.stepApplication.designMarketingMediaDescription
      ],
      complianceTestingAndShipping: [
        this.stepApplication.complianceTestingAndShipping
      ],
      complianceTestingAndShippingDescription: [
        this.stepApplication.complianceTestingAndShippingDescription
      ],
      otherExpenseOrActivity: [
        this.stepApplication.otherExpenseOrActivity
      ],
      otherExpenseOrActivityDescription: [
        this.stepApplication.otherExpenseOrActivityDescription
      ],
      heardAboutDescription: [
        this.stepApplication.heardAboutDescription,
        Validators.required
      ]
    });

    this.stepApplicationForm.valueChanges.subscribe(value => {
      if (value.hasOwnProperty('tradeShowsAndMissions')) { this.stepApplication.tradeShowsAndMissions = value.tradeShowsAndMissions; }
      if (value.hasOwnProperty('globalMarketEvents')) { this.stepApplication.globalMarketEvents = value.globalMarketEvents; }

      if (value.hasOwnProperty('usCommercialServices')) { this.stepApplication.usCommercialServices = value.usCommercialServices; }
      if (value.hasOwnProperty('exportWorkshops')) { this.stepApplication.exportWorkshops = value.exportWorkshops; }
      if (value.hasOwnProperty('ecommAndWebGlobalization')) {
        this.stepApplication.ecommAndWebGlobalization = value.ecommAndWebGlobalization;
      }
      if (value.hasOwnProperty('designMarketingMedia')) { this.stepApplication.designMarketingMedia = value.designMarketingMedia; }
      if (value.hasOwnProperty('complianceTestingAndShipping')) {
        this.stepApplication.complianceTestingAndShipping = value.complianceTestingAndShipping;
      }
      if (value.hasOwnProperty('otherExpenseOrActivity')) { this.stepApplication.otherExpenseOrActivity = value.otherExpenseOrActivity; }
      if (value.hasOwnProperty('heardAboutDescription')) { this.stepApplication.heardAboutDescription = value.heardAboutDescription; }

      // conditional fields
      if (value.tradeShowsAndMissionsDescription) {
        this.stepApplication.tradeShowsAndMissionsDescription = value.tradeShowsAndMissionsDescription;
      }
      if (value.globalMarketEventsDescription) { this.stepApplication.globalMarketEventsDescription = value.globalMarketEventsDescription; }
      if (value.usCommercialServicesDescription) {
        this.stepApplication.usCommercialServicesDescription = value.usCommercialServicesDescription;
      }
      if (value.exportWorkshopsDescription) { this.stepApplication.exportWorkshopsDescription = value.exportWorkshopsDescription; }
      if (value.ecommAndWebGlobalizationDescription) {
        this.stepApplication.ecommAndWebGlobalizationDescription = value.ecommAndWebGlobalizationDescription;
      }
      if (value.designMarketingMediaDescription) {
        this.stepApplication.designMarketingMediaDescription = value.designMarketingMediaDescription;
      }
      if (value.complianceTestingAndShippingDescription) {
        this.stepApplication.complianceTestingAndShippingDescription = value.complianceTestingAndShippingDescription;
      }
      if (value.otherExpenseOrActivityDescription) {
        this.stepApplication.otherExpenseOrActivityDescription = value.otherExpenseOrActivityDescription;
      }
    });

    this.companyDescriptionForm.valueChanges.subscribe(value => {
      if (value.hasOwnProperty('primaryActivity')) { this.stepApplication.primaryActivity = value.primaryActivity; }
      if (value.hasOwnProperty('naicsCode')) { this.stepApplication.naicsCode = value.naicsCode; }
      if (value.hasOwnProperty('yearEst')) { this.stepApplication.yearEst = value.yearEst; }
      if (value.hasOwnProperty('totalEmployees')) { this.stepApplication.totalEmployees = value.totalEmployees; }
      if (value.hasOwnProperty('forProfit')) { this.stepApplication.forProfit = value.forProfit; }
      if (value.hasOwnProperty('estGrossSalesLastYear')) { this.stepApplication.estGrossSalesLastYear = value.estGrossSalesLastYear; }
      if (value.hasOwnProperty('existingExportStrategy')) { this.stepApplication.existingExportStrategy = value.existingExportStrategy; }
      if (value.hasOwnProperty('estAnnualExportPercentage')) {
        this.stepApplication.estAnnualExportPercentage = value.estAnnualExportPercentage;
      }
      if (value.hasOwnProperty('exportLocation')) {
        this.stepApplication.exportLocation = value.exportLocation ? value.exportLocation.map(x => x.text) : [];
      }
      if (value.hasOwnProperty('exportLocationOtherDescription')) {
        this.stepApplication.exportLocationOtherDescription = value.exportLocationOtherDescription;
      }
      if (value.hasOwnProperty('exportLocationInterest')) {
        this.stepApplication.exportLocationInterest = value.exportLocationInterest ? value.exportLocationInterest.map(x => x.text) : [];
      }
      if (value.hasOwnProperty('exportLocationInterestOtherDescription')) {
        this.stepApplication.exportLocationInterestOtherDescription = value.exportLocationInterestOtherDescription;
      }
      if (value.hasOwnProperty('heardAboutDescription')) { this.stepApplication.heardAboutDescription = value.heardAboutDescription; }
      if (value.hasOwnProperty('heardAboutDescription')) { this.stepApplication.heardAboutDescription = value.heardAboutDescription; }

      if (value.primaryActivityDescription) { this.stepApplication.primaryActivityDescription = value.primaryActivityDescription; }
      if (value.primaryAffiliationDescription) { this.stepApplication.primaryAffiliationDescription = value.primaryAffiliationDescription; }
    });

    this.referralAgencyForm.valueChanges.subscribe(value => {
      this.stepApplication.referralAgency = value.referralAgency;
    })

    this.productInformationForm.valueChanges.subscribe(value => {

      if (value.hasOwnProperty('productDescription')) { this.stepApplication.productDescription = value.productDescription; }
      if (value.hasOwnProperty('salesChannelsDescription')) {
        this.stepApplication.salesChannelsDescription = value.salesChannelsDescription;
      }
      if (value.hasOwnProperty('isProductCertified')) { this.stepApplication.isProductCertified = value.isProductCertified; }
      if (value.hasOwnProperty('isForeignRepresentation')) {
        this.stepApplication.isForeignRepresentation = value.isForeignRepresentation;
      }
      if (value.hasOwnProperty('isExportUSOrigin')) { this.stepApplication.isExportUSOrigin = value.isExportUSOrigin; }
      if (value.usOriginContact) { this.stepApplication.usOriginContact = value.usOriginContact; }
      if (value.hasOwnProperty('optInSBA')) { this.stepApplication.optInSBA = value.optInSBA; }

      if (value.productCertifiedDescription) { this.stepApplication.productCertifiedDescription = value.productCertifiedDescription; }
      if (value.foreignRepresentationDescription) {
        this.stepApplication.foreignRepresentationDescription = value.foreignRepresentationDescription;
      }
      if (value.otherOrgsDescription) { this.stepApplication.otherOrgsDescription = value.otherOrgsDescription; }
    })

    for (const field of this.fields) {
      const form = this.companyDescriptionForm.get(field) ?
        this.companyDescriptionForm : this.productInformationForm.get(field) ?
          this.productInformationForm : this.stepApplicationForm.get(field) ? this.stepApplicationForm : null;

      if (form) {
        const value = form.controls[field]
          .value;
        const text = that.dict[field];
        // that.manageValidations(true, checkbox);
        that.manageValidations(value, text, form);
      }
    }

    for (const field of this.fields) {
      const form = this.companyDescriptionForm.get(field) ? this.companyDescriptionForm :
        this.productInformationForm.get(field) ? this.productInformationForm :
          this.stepApplicationForm.get(field) ? this.stepApplicationForm : null;

      if (form) {
        form.controls[
          field
        ].valueChanges.subscribe(value => {
          const text = that.dict[field];
          that.manageValidations(value, text, form);
        });
      }
    }

    this.validationService.form.setControl(
      'stepApplicationFormGroup',
      this.stepApplicationForm
    );

    this.validationService.form.setControl(
      'companyDescriptionForm',
      this.companyDescriptionForm
    );

    this.validationService.form.setControl(
      'productInformationForm',
      this.productInformationForm
    );

    this.validationService.form.setControl(
      'referralAgencyForm',
      this.referralAgencyForm
    )
  }

  ngOnChanges() {
    const that = this;
    if (this.isFormReadOnly()) {
      setTimeout(() => {
        that.stepApplicationForm.disable()
      }, 0);
    }
  }

  showExportLocationOtherDescription() {
    if (!this.stepApplication.exportLocation) {
      return false;
    }
    return this.stepApplication.exportLocation.filter(x => x === 'Other, please list').length > 0;
  }
  showExportLocationInterestOtherDescription() {

    if (!this.stepApplication.exportLocationInterest) {
      return false;
    }
    return this.stepApplication.exportLocationInterest.filter(x => x === 'Other, please list').length > 0;
  }

  isFormReadOnly() {
    if (this.userContext.currentUser.userType === userType.management.code) {
      return true;
    }
    if (
      this.form.currentFormStatus !== 'Pending' &&
      this.form.currentFormStatus !== 'Information Required'
    ) {
      return true;
    }
    return false;
  }

  changePrimaryActivity(type: any) {
    this.stepApplication.primaryActivity = type;
    if (type === 'Other') {
      this.isOtherPrimaryActivity = true;
    } else {
      this.isOtherPrimaryActivity = false;
    }
  }

  changePrimaryAffiliation(type: any) {
    const affiliations = [];
    let other = false;
    if (type.length > 0) {
      type.forEach(item => {
        affiliations.push(item.id);
        if (item.id === 'Other') { other = true; }
      })
    }
    this.stepApplication.primaryAffiliation = affiliations;
    if (other) {
      this.isOtherPrimaryAffiliation = true;
      this.manageValidations('Other', 'primaryAffiliationDescription', this.companyDescriptionForm);
    } else {
      this.isOtherPrimaryAffiliation = false;
      this.manageValidations(false, 'primaryAffiliationDescription', this.companyDescriptionForm);
    }
  }

  changeOtherOrgs(type: any) {
    const orgs = [];
    let other = false;
    if (type.length > 0) {
      type.forEach(item => {
        orgs.push(item.id);
        if (item.id === 'Other') { other = true; }
      })
    }
    this.stepApplication.otherOrgs = orgs;
    if (other) {
      this.isOtherFederalOrg = true;
      this.manageValidations('Other', 'otherOrgsDescription', this.productInformationForm);
    } else {
      this.isOtherFederalOrg = false;
      this.manageValidations(false, 'otherOrgsDescription', this.productInformationForm);
    }
  }

  changeBusinessType(type: any) {
    const businessTypes = [];
    if (type.length > 0) {
      type.forEach(item => businessTypes.push(item.id))
    }
    if (businessTypes.length > 0 && businessTypes.indexOf('N/A') > -1) {
      this.stepApplication.businessType = ['N/A'];
    }
    this.stepApplication.businessType = businessTypes;
  }

  enableLegendPopover() {
    $(function() {
      $('[data-toggle="popover"]').popover();
    });
  }

  manageValidations(value: any, text: string, formGroup: FormGroup) {
    const that = this;
    const type = typeof value;
    if (type === 'string' && value === 'Other') {
      if (formGroup.controls[text]) {
        formGroup.controls[text].setValidators(
          Validators.required
        );
        formGroup.controls[text].updateValueAndValidity();
      }

    } else if (type !== 'string' && value) {
      if (formGroup.controls[text]) {
        formGroup.controls[text].setValidators(
          Validators.required
        );
        formGroup.controls[text].updateValueAndValidity();
      }
    } else {
      if (formGroup.controls.hasOwnProperty(text)) {
        formGroup.controls[text].clearValidators();
        formGroup.controls[text].reset();
        formGroup.controls[text].updateValueAndValidity();
      }

    }
  }

  preventNonNumeric(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
